import { BASE_URL } from '@/config/env';
import { GeneratedImage } from '@/types';

export function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export interface ApiImageInfo {
  id?: string;
  url: string;
  filename: string;
  timestamp: number;
  params?: Record<string, any>;
}

export function mapApiImageToGenerated(img: ApiImageInfo): GeneratedImage {
  const imageId = img.id || generateUUID();
  const rawUrl = img.url ?? '';
  const url = rawUrl.startsWith('http') || rawUrl.startsWith('data:') ? rawUrl : (rawUrl ? `${BASE_URL}${rawUrl}` : '');
  return {
    id: imageId,
    url,
    filename: img.filename,
    timestamp: typeof img.timestamp === 'number' ? img.timestamp : new Date(img.timestamp).getTime(),
    params: img.params || {},
    mimeType: 'image/jpeg',
  };
}

export function resolveImageUrl(url: string): string {
  return url.startsWith('http') || url.startsWith('data:') ? url : `${BASE_URL}${url}`;
}
